import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "../../../../Components/CSS/TableStyle.css";
import StaffBody from "../StaffBody/StaffBody";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import StaffFilter from "../StaffFilter/StaffFilter";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { connect } from "react-redux";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 5,
      page: 0,
      data: {
        employeeName: "",
        department: "",
        mobileNumber: "",
        designation: "",
        email: "",
        maritalStatus: "",
        gender: " ",
        type: " ",
      },
      searchBy: {
        employeeName: "",
        department: "",
      },
      column: [
        { name: "S.N." },
        { name: "Employee Name" },
        { name: "Gender" },
        { name: "Email" },
        { name: "Department" },
        { name: "Designation" },
        { name: "Marital Status" },
        { name: "Mobile" },
        { name: "Actions" },
      ],
      staffs: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getStaffsData();
  }

  getStaffsData = async () => {
    try {
      const response = await Axios.get(`${url}/api/staffs`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.staffs.length !== 0) {
        this.setState({
          staffs: response.data.staffs,
          isEmpty: false,
        });
      } else {
        this.setState({
          staffs: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStaffsData();
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSearch = (e) => {
    this.setState({
      searchBy: {
        ...this.state.searchBy,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;

    const filtered = this.state.staffs.filter((staff) => {
      return (
        staff.fullName
          .toLowerCase()
          .indexOf(this.state.searchBy.employeeName.toLowerCase()) !== -1 &&
        staff.department
          .toLowerCase()
          .indexOf(this.state.searchBy.department.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Employee List"
            refreshUrl={this.props.match.url}
            addUrl={"/administration/staffs/add"}
            urlTitle="Add Staff"
          />

          {this.state.staffs.length !== 0 && (
            <StaffFilter
              data={this.state.searchBy}
              handleSearch={this.handleSearch}
            />
          )}

          {this.state.staffs.length !== 0 ? (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />

                <TableBody>
                  {(rowsPerPage > 0
                    ? filtered.slice(
                        rowsPerPage * page,
                        rowsPerPage * page + rowsPerPage
                      )
                    : filtered
                  ).map((staff, index) => (
                    <StaffBody
                      data={staff}
                      key={index}
                      index={index}
                      getStaffsData={this.getStaffsData}
                    />
                  ))}
                </TableBody>

                <CustomTableFooter
                  count={filtered.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
            </TableContainer>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewStaff)));
